<template>
  <div class="box">
    <el-container class="box1">
      <el-aside>
        <el-row class="tac">
          <el-col :span="24">
            <el-menu default-active="1-1" class="el-menu-vertical-demo" active-text-color="#ffffff">
              <el-submenu index="1">
                <template slot="title">
                  <i class="el-icon-document"></i>
                  <span style="font-size: 20px">我的论文</span>
                </template>
                <el-menu-item-group>
                  <!-- <template slot="title"></template> -->
                  <el-menu-item index="1-1" @click="changFlag(1, 2)">
                    <i class="el-icon-receiving"></i>
                    <span>当前投稿</span>
                  </el-menu-item>
                  <el-menu-item index="1-2" @click="changFlag(1, 1)">
                    <i class="el-icon-edit-outline"></i>
                    <span>预设稿件</span>
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </el-menu>
          </el-col>
        </el-row>
      </el-aside>
      <div>
        <el-container class="r_box" v-if="isFlag == 1">
          <el-main>
            <div class="r_tle">
              <i class="el-icon-receiving"></i>
              <p>当前投稿</p>
              <span>投稿中 </span>
            </div>
            <div class="r_btn">
              <div v-for="(item, i) in arrBut" :key="i" class="r_btn_item" :class="{ act: actNum == i + 1 }"
                @click="changeList(i + 1, 1)">
                {{ item }}
              </div>
            </div>
          </el-main>
          <el-footer>
            <div class="r_fter">
              <el-table :data="tableData" border height="300" style="width: 100%" :header-cell-style="{
                background: '#f9fafe',
                color: '#00599e',
                borderColor: '#eeeeee'
              }">
                <el-table-column prop="stus" label="状态"> </el-table-column>

                <el-table-column prop="id" label="论文编号"> </el-table-column>
                <el-table-column prop="title" label="论文标题">
                </el-table-column>
                <el-table-column prop="addtime" label="时间"> </el-table-column>

                <el-table-column prop="date" label="操作" width="180">
                  <template slot-scope="scope">
                    <div class="fon_flx">
                      <p class="unlod" @click="openFlie(scope.row)">
                        下载
                      </p>
                      <div class="unlod">撤稿</div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-footer>
        </el-container>
        <div v-else>
          <el-container class="r_box">
            <el-main>
              <div class="r_tle">
                <i class="el-icon-receiving"></i>
                <p>当前投稿</p>
                <span>投稿中 </span>
              </div>
              <div class="r_btn">
                <div v-for="(item, i) in arrBut" :key="i" class="r_btn_item" :class="{ act: actNum == i + 1 }"
                  @click="changeList(i + 1, 1)">
                  {{ item }}
                </div>
              </div>
            </el-main>
            <el-footer>
              <div class="r_fter">
                <el-table :data="tableData" border height="300" style="width: 100%" :header-cell-style="{
                  background: '#f9fafe',
                  color: '#00599e',
                  borderColor: '#eeeeee'
                }">
                  <el-table-column prop="stus" label="状态"> </el-table-column>

                  <el-table-column prop="id" label="论文编号">
                  </el-table-column>
                  <el-table-column prop="title" label="论文标题">
                  </el-table-column>
                  <el-table-column prop="addtime" label="时间">
                  </el-table-column>

                  <el-table-column prop="date" label="操作" width="180">
                    <template slot-scope="scope">
                      <div class="fon_flx">
                        <p class="unlod" @click="openFlie(scope.row)">
                          下载
                        </p>
                        <div class="unlod">修改</div>

                        <div class="unlod" @click="delPren(scope.row.id)">
                          删除
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-footer>
          </el-container>
        </div>
      </div>
      <div></div>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      arrBut: ['会议论文投稿', '科普作品投稿'],
      actNum: 1,
      tableData: [{}],
      ruleForm: {
        type: []
      },
      isFlag: 1,
      rules: {
        name: [
          { require: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.init(1, 2)
  },
  components: {},
  methods: {
    openFlie(val) {
      window.open(val.fileurl, '_blank')

      // const a = document.createElement('a')
      // a.download = true
      // a.style.display = 'block'
      // a.href = val.fileurl
      // // 触发点击
      // document.body.appendChild(a)
      // a.click()
      // // 然后移除
      // document.body.removeChild(a)
    },
    delPren(id) {
      this.$confirm('是否删除选中', '系统提示', { type: 'warning' })
        .then(async () => {
          let res = await this.$api.Home.delPre({ id })
          if (res.code === 0) {
            this.$message.success('删除成功')
            this.init(1, this.actNum)
          } else {
            this.$message.error(res.msg)
          }
          done()
        })
        .catch(() => { })
    },
    changFlag(val, val1) {
      this.isFlag = val
      this.init(val, val1)
    },
    changeList(i, ii) {
      this.actNum = i
      this.init(i, ii)
    },
    async init(i, ii) {
      let res = await this.$api.Home.histList({ type: this.actNum, status: ii })
      if (res.code == 0) {
        this.tableData = res.data
        if (res.count == 0) {
        } else {
        }
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.act {
  background-color: #00599e !important;
}

.fon_flx {
  display: flex;
  justify-content: space-evenly;

  .unlod {
    color: #00599e;
    cursor: pointer;
  }
}

/deep/ .el-menu-item {
  height: 60px;
  line-height: 60px;
  font-size: 20px;
}

.r_btn_item {
  width: 170px;
  height: 50px;
  background-color: #84afd7;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  color: #ffffff;
  cursor: pointer;
}
</style>
